var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_title"},[_c('h2',{style:({ color: _vm.titleColor })},[_vm._t("title")],2),_c('h5',{class:{ color: _vm.subColor }},[_vm._t("sub")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }